import React, { useState, useEffect } from "react";
import {
  FieldInputNumber,
  ManageRkaasLayout,
  SearchableList,
  FieldDropSide,
  FormLeaveGuard,
} from "../../../../../components";
import * as Yup from "yup";
import { Form } from "react-bootstrap";
import { isEmpty } from "lodash";
import { Field, Formik } from "formik";
import {
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  errors,
} from "../../../../../utils";

const initialValues = {};

const AddMarketTimingRules = (props) => {
  const {
    fields,
    marketTimingRules,
    setMarketTimingRules,
    edit,
    setEdit,
    data,
    isInnerFormDirty,
    setIsInnerFormDirty,
    addMarketTimingRuleClick,
    setTabGrey,
  } = props;

  const formValues = {
    [fields.roadTripOccurance]: edit
      ? data.roadTripOccurance
      : marketTimingRules?.length + 1,
    [fields.daysBetweenTransfer]: edit ? data.daysBetweenTransfer : null,
    [fields.failedRuleResult]: edit ? data.failedRuleResult : null,
    [fields.daysToBlockFutureTransfers]: edit
      ? data.daysToBlockFutureTransfers
      : null,
  };

  const schema = Yup.object().shape({
    daysBetweenTransfer: Yup.number()
      .required(errors.daysBetweenTransfers.required)
      .nullable(),
    failedRuleResult: Yup.number()
      .required(errors.failedRuleResult.required)
      .nullable(),
    daysToBlockFutureTransfers: Yup.number().when("failedRuleResult", {
      is: (value) => value && value == 3,
      then: Yup.number()
        .required(errors.daysToBlockFutureTransaction.required)
        .nullable(),
      otherwise: Yup.number().nullable(),
    }),
  });

  const [showDirtyCheckModal, setShowDirtyCheckModal] = useState(false);

  useEffect(() => {
    return () => setIsInnerFormDirty(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFormToggle = () => {
    if (isInnerFormDirty) {
      setShowDirtyCheckModal(true);
    } else {
      addMarketTimingRuleClick();
    }
  };

  const handleConfirmClick = () => {
    addMarketTimingRuleClick();
  };

  const handleCancelClick = () => {
    setShowDirtyCheckModal(false);
  };

  const onFormSubmit = (values) => {
    if (data.roadTripOccurance == values.roadTripOccurance && edit) {
      setMarketTimingRules(
        marketTimingRules.map((item, index) => {
          if (item.roadTripOccurance == values.roadTripOccurance) return values;
          else return item;
        })
      );
    } else setMarketTimingRules([...marketTimingRules, values]);
    setEdit(false);
    addMarketTimingRuleClick();
  };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setEdit(false);
        onFormToggle();
      },
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
    },
  ];

  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validationSchema={schema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        values,
        dirty,
        ...rest
      }) => {
        if (isInnerFormDirty !== dirty) {
          setIsInnerFormDirty(dirty);
        }

        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <ManageRkaasLayout
              buttons={buttons}
              layoutHeader={"Market Timing Rules"}
            >
              <div className="line-separator" />
              <Field
                size="smd"
                name={fields.roadTripOccurance}
                label={"Road trip occurance"}
                type="number"
                value={values[fields.roadTripOccurance]}
                component={FieldInputNumber}
                disabled={true}
                isRequired
              />
              <Field
                size="smd"
                name={fields.daysBetweenTransfer}
                label={"Days between Transfer"}
                isRequired
                type="number"
                autoComplete="off"
                value={values[fields.daysBetweenTransfer]}
                component={FieldInputNumber}
                min={1}
                max={999}
                onChange={(e) => {
                  setTabGrey(3);
                  handleChange(e);
                }}
              />

              <Field
                name={fields.failedRuleResult}
                label="Failed rule result"
                value={values[fields.failedRuleResult]}
                isRequired
                options={toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.FAILED_RULE_RESULT
                )}
                popupContent={
                  <SearchableList
                    isRadio
                    isNotTypeAhead
                    label="Select"
                    selectedValue={values[fields.failedRuleResult]}
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.FAILED_RULE_RESULT
                    )}
                    onSelect={(value) => {
                      setTabGrey(3);
                      setFieldValue(fields.failedRuleResult, value);
                      setFieldValue(fields.daysToBlockFutureTransfers, null);
                    }}
                  />
                }
                component={FieldDropSide}
              />
              {values[fields.failedRuleResult] == 3 && (
                <Field
                  size="smd"
                  name={fields.daysToBlockFutureTransfers}
                  label={"Number of days to block future Transfers"}
                  type="number"
                  autoComplete="off"
                  isRequired
                  value={values[fields.daysToBlockFutureTransfers]}
                  component={FieldInputNumber}
                  max={999}
                  onChange={(e) => {
                    setTabGrey(3);
                    handleChange(e);
                  }}
                />
              )}
            </ManageRkaasLayout>
            <FormLeaveGuard
              showModal={showDirtyCheckModal}
              handleConfirmClick={handleConfirmClick}
              handleCancelClick={handleCancelClick}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddMarketTimingRules;
